import { render, staticRenderFns } from "./AmountPacienteChart.vue?vue&type=template&id=1d233063&scoped=true&"
import script from "./AmountPacienteChart.vue?vue&type=script&lang=js&"
export * from "./AmountPacienteChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d233063",
  null
  
)

export default component.exports